import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import * as React from 'react';
import { escape_html } from '../chat/utils/chat_utils';

// History Log label for an email that never reached its recipient. `failure` is the MessageLog
// serializer's delivery_failure: { state, label, reason, detail } (detail = the raw provider error).
const RETRYING_COLORS = { color: '#8A5300', background: '#FFF4E5' };
const FAILED_COLORS = { color: '#B3261E', background: '#FDECEA' };

// Amber while the email may still arrive (retrying, or the mail service never confirmed it); red once it can't.
const PENDING_STATES = ['retrying', 'unconfirmed'];

export const deliveryFailureColors = (failure) => (
    PENDING_STATES.includes(failure?.state) ? RETRYING_COLORS : FAILED_COLORS
);

export const deliveryFailureHtml = (failure) => {
    const { color } = deliveryFailureColors(failure);
    return `<span style="color:${color};font-size:14px;font-weight:500;">&#9888; ${escape_html(failure.label)}</span>`
        + ` <span style="color:${color};font-size:14px;">${escape_html(failure.reason)}</span>`;
};

export default function EmailDeliveryFailure({ failure }) {
    if (!failure) return null;
    const { color, background } = deliveryFailureColors(failure);
    return (
        <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: '4px 6px', fontSize: '14px', marginLeft: '3px' }}>
            <span
                title={failure.detail || undefined}
                style={{ display: 'inline-flex', alignItems: 'center', gap: '4px', fontWeight: 500, fontSize: '13px', padding: '1px 8px 1px 4px', borderRadius: '10px', color, backgroundColor: background }}
            >
                <ErrorOutlineIcon style={{ fontSize: '16px' }} />
                {failure.label}
            </span>
            <span style={{ color }}>{failure.reason}</span>
        </div>
    );
}
